import { UserRole, UserRoleType } from './user_role';

export type TeamUserType = 'project' | 'workspace';

class TeamUser {
  hash: string = (Math.random() + 1).toString(36).substring(7);
  readonly email: string = '';
  role: UserRoleType = 'creator';
  readonly image: string = '';
  readonly teamType: TeamUserType;
  readonly isAdded: boolean = false;
  leaving: boolean = false;
  leavingData?: LeavingData;

  constructor(email: string, role: UserRoleType, team_type: TeamUserType, image: string, isAdded: boolean) {
    const defaultImage = image.includes('http') ? image : `/assets/new_theme/user_avatar/${this.generateAvatarFilename(email)}`;

    this.email = email;
    this.role = role;
    this.image = isAdded ? image : defaultImage;
    this.teamType = team_type;
    this.isAdded = isAdded;

    this.isOwner = this.isOwner.bind(this);
    this.changeRole = this.changeRole.bind(this);
    this.generateId = this.generateId.bind(this);
    this.leave = this.leave.bind(this);
    this.json = this.json.bind(this);
  }

  isOwner() {
    return this.role === UserRole.Owner;
  }

  changeRole(newRole: UserRoleType) {
    this.role = newRole;
    this.leaving = false;
    this.leavingData = undefined;
    this.generateId();
  }

  generateId() {
    this.hash = (Math.random() + 1).toString(36).substring(7);
  }

  leave(keepPersonalData: boolean) {
    this.leaving = true;
    this.leavingData = {
      keepPersonalData,
    };
    this.generateId();
  }

  json() {
    return {
      email: this.email,
      role: this.role,
      leaving: this.leaving,
      leavingData: this.leavingData,
    };
  }

  generateAvatarFilename(email: string): string {
    // Simple hash function to produce a 16-bit integer
    let hash = 0;
    for (let i = 0; i < email.length; i++) {
      const char = email.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash &= 0xffff; // Convert to 16-bit integer
    }

    // Use the hash to cycle between avatar_1.png to avatar_8.png
    const avatarNumber = (Math.abs(hash) % 8) + 1;
    return `avatar_${avatarNumber}.png`;
  }
}

export default TeamUser;

type LeavingData = {
  keepPersonalData: boolean;
};
